export const roomTitle = {
  type: "string",
  minLength: 1,
  maxLength: 255,
  transform: ["trim"]
};
